<script>
    import axios from 'axios'

    export default {
        methods: {
            axios_post(url, data) {
                console.log(url);
                const my_axios = axios.post(url, data);

                return new Promise((resolve, reject) => {
                    my_axios.then((res) => {
                        console.log(res);

                        let response_url = "";
                        if (res.request.responseURL !== undefined) {
                            response_url = res.request.responseURL;
                        }

                        if (response_url != "") {
                            if (response_url.indexOf("Login/Index") >= 0) {
                                alert('セッションタイムアウトしました。ログイン画面に戻ります');
                                location.href = "/Login/Index";
                            }
                        }

                        resolve(res);
                    });
                    my_axios.catch((err)  => {
                        console.log(err);
                        reject(err);
                    });
                });
            },
            axios_post_json(url, data) {
                console.log(url);
                const headers = {
                    'Content-Type': 'application/json',
                    'Accept-Encoding': 'gzip',
                    'Accept-Charset': 'utf-8',
                    'Content-Encoding': 'gzip',
                };
                console.log(headers);
                const options = {
                    url: url,
                    method: 'post',
                    headers: headers,
                    json: true,
                    data: data,
                };

                const myAxios = axios.request(options);

                return new Promise((resolve, reject) => {
                    myAxios.then((res) => {
                        console.log(res);
                        resolve(res);
                    });
                    myAxios.catch((err) => {
                        console.log(err);
                        reject(err);
                    });
                });
            },
        }
    }
</script>
